/**
 * A value linked to the next message sent, so that message's analytics event can carry it. Matched
 * on the sent text and cleared on read, so a typed or later message never inherits it.
 */
export function createSendTag<T>() {
  let pending: { text: string; value: T } | null = null;

  return {
    set(tag: { text: string; value: T }): void {
      pending = tag;
    },
    consumeFor(submittedText: string | undefined): T | undefined {
      const tag = pending;
      pending = null;
      return tag && tag.text.trim() === submittedText?.trim() ? tag.value : undefined;
    },
  };
}
